var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/rrTray.j2"] = require( "macros/rrTray.j2" );
dependencies["macros/contentful/split-module.j2"] = require( "macros/contentful/split-module.j2" );
dependencies["macros/contentful/giveaway-module.j2"] = require( "macros/contentful/giveaway-module.j2" );
dependencies["macros/contentful/product-tray-module.j2"] = require( "macros/contentful/product-tray-module.j2" );
dependencies["macros/contentful-module-spacing.j2"] = require( "macros/contentful-module-spacing.j2" );
dependencies["macros/contentful/components/markdown-component.j2"] = require( "macros/contentful/components/markdown-component.j2" );
dependencies["macros/contentful/components/image-macro.j2"] = require( "macros/contentful/components/image-macro.j2" );
dependencies["contentful/template-component.j2"] = require( "contentful/template-component.j2" );
dependencies["contentful/collections-component.j2"] = require( "contentful/collections-component.j2" );
dependencies["contentful/accordion-module.j2"] = require( "contentful/accordion-module.j2" );
dependencies["contentful/content-accordion-module.j2"] = require( "contentful/content-accordion-module.j2" );
dependencies["contentful/carousel-module.j2"] = require( "contentful/carousel-module.j2" );
dependencies["contentful/video-component.j2"] = require( "contentful/video-component.j2" );
dependencies["contentful/ugc-module.j2"] = require( "contentful/ugc-module.j2" );
dependencies["contentful/iframe-component.j2"] = require( "contentful/iframe-component.j2" );
dependencies["contentful/editorial-component.j2"] = require( "contentful/editorial-component.j2" );
dependencies["contentful/text-over-image-component-outer.j2"] = require( "contentful/text-over-image-component-outer.j2" );
dependencies["contentful/giveaway-component.j2"] = require( "contentful/giveaway-component.j2" );
dependencies["contentful/shoppable/shoppable-image-component.j2"] = require( "contentful/shoppable/shoppable-image-component.j2" );
dependencies["contentful/product-grid/product-grid-component.j2"] = require( "contentful/product-grid/product-grid-component.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/contentful/render-entry.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/rrTray.j2", false, "core/templates/macros/contentful/render-entry.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("richRelevanceTray")) {
var t_4 = t_1.richRelevanceTray;
} else {
cb(new Error("cannot import 'richRelevanceTray'")); return;
}
context.setVariable("richRelevanceTray", t_4);
env.getTemplate("macros/contentful/split-module.j2", false, "core/templates/macros/contentful/render-entry.j2", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
t_5.getExported(context.getVariables(), frame, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
if(t_5.hasOwnProperty("splitModule")) {
var t_8 = t_5.splitModule;
} else {
cb(new Error("cannot import 'splitModule'")); return;
}
context.setVariable("splitModule", t_8);
env.getTemplate("macros/contentful/giveaway-module.j2", false, "core/templates/macros/contentful/render-entry.j2", false, function(t_10,t_9) {
if(t_10) { cb(t_10); return; }
t_9.getExported(context.getVariables(), frame, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
if(t_9.hasOwnProperty("giveawayModule")) {
var t_12 = t_9.giveawayModule;
} else {
cb(new Error("cannot import 'giveawayModule'")); return;
}
context.setVariable("giveawayModule", t_12);
env.getTemplate("macros/contentful/product-tray-module.j2", false, "core/templates/macros/contentful/render-entry.j2", false, function(t_14,t_13) {
if(t_14) { cb(t_14); return; }
t_13.getExported(context.getVariables(), frame, function(t_15,t_13) {
if(t_15) { cb(t_15); return; }
if(t_13.hasOwnProperty("productTrayModule")) {
var t_16 = t_13.productTrayModule;
} else {
cb(new Error("cannot import 'productTrayModule'")); return;
}
context.setVariable("productTrayModule", t_16);
env.getTemplate("macros/contentful-module-spacing.j2", false, "core/templates/macros/contentful/render-entry.j2", false, function(t_18,t_17) {
if(t_18) { cb(t_18); return; }
t_17.getExported(function(t_19,t_17) {
if(t_19) { cb(t_19); return; }
if(t_17.hasOwnProperty("getBottomMarginClasses")) {
var t_20 = t_17.getBottomMarginClasses;
} else {
cb(new Error("cannot import 'getBottomMarginClasses'")); return;
}
context.setVariable("getBottomMarginClasses", t_20);
env.getTemplate("macros/contentful/components/markdown-component.j2", false, "core/templates/macros/contentful/render-entry.j2", false, function(t_22,t_21) {
if(t_22) { cb(t_22); return; }
t_21.getExported(function(t_23,t_21) {
if(t_23) { cb(t_23); return; }
if(t_21.hasOwnProperty("markdownComponent")) {
var t_24 = t_21.markdownComponent;
} else {
cb(new Error("cannot import 'markdownComponent'")); return;
}
context.setVariable("markdownComponent", t_24);
env.getTemplate("macros/contentful/components/image-macro.j2", false, "core/templates/macros/contentful/render-entry.j2", false, function(t_26,t_25) {
if(t_26) { cb(t_26); return; }
t_25.getExported(context.getVariables(), frame, function(t_27,t_25) {
if(t_27) { cb(t_27); return; }
if(t_25.hasOwnProperty("buildImage")) {
var t_28 = t_25.buildImage;
} else {
cb(new Error("cannot import 'buildImage'")); return;
}
context.setVariable("buildImage", t_28);
var macro_t_29 = runtime.makeMacro(
[], 
["entry", "isSpecialtyShop", "entryloop", "isLazy", "displayType", "stackedOnSmall", "isMobileSlider"], 
function (kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("entry", kwargs.hasOwnProperty("entry") ? kwargs["entry"] : {});
frame.set("isSpecialtyShop", kwargs.hasOwnProperty("isSpecialtyShop") ? kwargs["isSpecialtyShop"] : false);
frame.set("entryloop", kwargs.hasOwnProperty("entryloop") ? kwargs["entryloop"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("isLazy", kwargs.hasOwnProperty("isLazy") ? kwargs["isLazy"] : false);
frame.set("displayType", kwargs.hasOwnProperty("displayType") ? kwargs["displayType"] : runtime.contextOrFrameLookup(context, frame, "displayType"));
frame.set("stackedOnSmall", kwargs.hasOwnProperty("stackedOnSmall") ? kwargs["stackedOnSmall"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("isMobileSlider", kwargs.hasOwnProperty("isMobileSlider") ? kwargs["isMobileSlider"] : runtime.contextOrFrameLookup(context, frame, "False"));
var t_30 = "";if((lineno = 10, colno = 21, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"sys"]))) {
t_30 += "\n\n        ";
var t_31;
t_31 = (lineno = 12, colno = 40, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"sys.contentType.sys.moduleIndex",0]));
frame.set("moduleIndex", t_31, true);
if(frame.topLevel) {
context.setVariable("moduleIndex", t_31);
}
if(frame.topLevel) {
context.addExport("moduleIndex", t_31);
}
t_30 += "\n        ";
var t_32;
t_32 = (lineno = 13, colno = 42, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"sys.contentType.sys.moduleIndex",0]));
frame.set("multipleIndex", t_32, true);
if(frame.topLevel) {
context.setVariable("multipleIndex", t_32);
}
if(frame.topLevel) {
context.addExport("multipleIndex", t_32);
}
t_30 += "\n        ";
var t_33;
t_33 = (lineno = 14, colno = 39, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"sys.contentType.sys.id","Unknown Module Type"]));
frame.set("moduleType", t_33, true);
if(frame.topLevel) {
context.setVariable("moduleType", t_33);
}
if(frame.topLevel) {
context.addExport("moduleType", t_33);
}
t_30 += "\n        ";
var t_34;
t_34 = runtime.contextOrFrameLookup(context, frame, "entryloop");
frame.set("entryloop", t_34, true);
if(frame.topLevel) {
context.setVariable("entryloop", t_34);
}
if(frame.topLevel) {
context.addExport("entryloop", t_34);
}
t_30 += "\n        ";
var t_35;
t_35 = runtime.contextOrFrameLookup(context, frame, "isLazy");
frame.set("isLazy", t_35, true);
if(frame.topLevel) {
context.setVariable("isLazy", t_35);
}
if(frame.topLevel) {
context.addExport("isLazy", t_35);
}
t_30 += "\n\n        ";
t_30 += "\n        ";
var t_36;
t_36 = ((lineno = 19, colno = 36, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product",runtime.contextOrFrameLookup(context, frame, "False")]))?runtime.contextOrFrameLookup(context, frame, "True"):"");
frame.set("isForPDP", t_36, true);
if(frame.topLevel) {
context.setVariable("isForPDP", t_36);
}
if(frame.topLevel) {
context.addExport("isForPDP", t_36);
}
t_30 += "\n        ";
var t_37;
t_37 = (lineno = 20, colno = 33, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["category.categorySlug","PAGE_TYPE"]));
frame.set("eventCategory", t_37, true);
if(frame.topLevel) {
context.setVariable("eventCategory", t_37);
}
if(frame.topLevel) {
context.addExport("eventCategory", t_37);
}
t_30 += "\n        ";
var t_38;
t_38 = (runtime.contextOrFrameLookup(context, frame, "isForPDP")?"editorial content click":"content");
frame.set("eventAction", t_38, true);
if(frame.topLevel) {
context.setVariable("eventAction", t_38);
}
if(frame.topLevel) {
context.addExport("eventAction", t_38);
}
t_30 += "\n\n        ";
if(runtime.contextOrFrameLookup(context, frame, "moduleType") == "markdownModule") {
t_30 += "\n            ";
t_30 += runtime.suppressValue((lineno = 24, colno = 30, runtime.callWrap(t_24, "markdownComponent", context, [runtime.contextOrFrameLookup(context, frame, "entry"),runtime.contextOrFrameLookup(context, frame, "markdown_params")])), env.opts.autoescape);
t_30 += "\n        ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "moduleType") == "templateComponent") {
t_30 += "\n            ";
env.getTemplate("contentful/template-component.j2", false, "core/templates/macros/contentful/render-entry.j2", null, function(t_41,t_39) {
if(t_41) { cb(t_41); return; }
t_39.render(context.getVariables(), frame, function(t_42,t_40) {
if(t_42) { cb(t_42); return; }
t_30 += t_40
t_30 += "\n        ";
})});
}
else {
if(runtime.contextOrFrameLookup(context, frame, "moduleType") == "collectionsComponent") {
t_30 += "\n            ";
env.getTemplate("contentful/collections-component.j2", false, "core/templates/macros/contentful/render-entry.j2", null, function(t_45,t_43) {
if(t_45) { cb(t_45); return; }
t_43.render(context.getVariables(), frame, function(t_46,t_44) {
if(t_46) { cb(t_46); return; }
t_30 += t_44
t_30 += "\n        ";
})});
}
else {
if(runtime.contextOrFrameLookup(context, frame, "moduleType") == "accordionContentModule") {
t_30 += "\n            ";
env.getTemplate("contentful/accordion-module.j2", false, "core/templates/macros/contentful/render-entry.j2", null, function(t_49,t_47) {
if(t_49) { cb(t_49); return; }
t_47.render(context.getVariables(), frame, function(t_50,t_48) {
if(t_50) { cb(t_50); return; }
t_30 += t_48
t_30 += "\n        ";
})});
}
else {
if(runtime.contextOrFrameLookup(context, frame, "moduleType") == "shopTheLookAccordionContentModule") {
t_30 += "\n            ";
env.getTemplate("contentful/content-accordion-module.j2", false, "core/templates/macros/contentful/render-entry.j2", null, function(t_53,t_51) {
if(t_53) { cb(t_53); return; }
t_51.render(context.getVariables(), frame, function(t_54,t_52) {
if(t_54) { cb(t_54); return; }
t_30 += t_52
t_30 += "\n        ";
})});
}
else {
if(runtime.contextOrFrameLookup(context, frame, "moduleType") == "mediaCarouselSingleModule") {
t_30 += "\n            ";
env.getTemplate("contentful/carousel-module.j2", false, "core/templates/macros/contentful/render-entry.j2", null, function(t_57,t_55) {
if(t_57) { cb(t_57); return; }
t_55.render(context.getVariables(), frame, function(t_58,t_56) {
if(t_58) { cb(t_58); return; }
t_30 += t_56
t_30 += "\n        ";
})});
}
else {
if(runtime.contextOrFrameLookup(context, frame, "moduleType") == "carouselPageContentModule") {
t_30 += "\n            ";
env.getTemplate("contentful/carousel-module.j2", false, "core/templates/macros/contentful/render-entry.j2", null, function(t_61,t_59) {
if(t_61) { cb(t_61); return; }
t_59.render(context.getVariables(), frame, function(t_62,t_60) {
if(t_62) { cb(t_62); return; }
t_30 += t_60
t_30 += "\n        ";
})});
}
else {
if(runtime.contextOrFrameLookup(context, frame, "moduleType") == "imageComponent") {
t_30 += "\n            ";
t_30 += runtime.suppressValue((lineno = 38, colno = 23, runtime.callWrap(t_28, "buildImage", context, [runtime.contextOrFrameLookup(context, frame, "entry"),runtime.makeKeywordArgs({"experience": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"experience"),"defaultEventCategory": runtime.contextOrFrameLookup(context, frame, "eventCategory"),"defaultEventAction": runtime.contextOrFrameLookup(context, frame, "eventAction")})])), env.opts.autoescape);
t_30 += "\n        ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "moduleType") == "videoComponent") {
t_30 += "\n            ";
env.getTemplate("contentful/video-component.j2", false, "core/templates/macros/contentful/render-entry.j2", null, function(t_65,t_63) {
if(t_65) { cb(t_65); return; }
t_63.render(context.getVariables(), frame, function(t_66,t_64) {
if(t_66) { cb(t_66); return; }
t_30 += t_64
t_30 += "\n        ";
})});
}
else {
if(runtime.contextOrFrameLookup(context, frame, "moduleType") == "ugcModule") {
t_30 += "\n            ";
env.getTemplate("contentful/ugc-module.j2", false, "core/templates/macros/contentful/render-entry.j2", null, function(t_69,t_67) {
if(t_69) { cb(t_69); return; }
t_67.render(context.getVariables(), frame, function(t_70,t_68) {
if(t_70) { cb(t_70); return; }
t_30 += t_68
t_30 += "\n        ";
})});
}
else {
if(runtime.contextOrFrameLookup(context, frame, "moduleType") == "componentIFrame") {
t_30 += "\n            ";
env.getTemplate("contentful/iframe-component.j2", false, "core/templates/macros/contentful/render-entry.j2", null, function(t_73,t_71) {
if(t_73) { cb(t_73); return; }
t_71.render(context.getVariables(), frame, function(t_74,t_72) {
if(t_74) { cb(t_74); return; }
t_30 += t_72
t_30 += "\n        ";
})});
}
else {
if(runtime.contextOrFrameLookup(context, frame, "moduleType") == "editorialComponent") {
t_30 += "\n            ";
env.getTemplate("contentful/editorial-component.j2", false, "core/templates/macros/contentful/render-entry.j2", null, function(t_77,t_75) {
if(t_77) { cb(t_77); return; }
t_75.render(context.getVariables(), frame, function(t_78,t_76) {
if(t_78) { cb(t_78); return; }
t_30 += t_76
t_30 += "\n        ";
})});
}
else {
if(runtime.contextOrFrameLookup(context, frame, "moduleType") == "textOverImageComponent") {
t_30 += "\n            ";
env.getTemplate("contentful/text-over-image-component-outer.j2", false, "core/templates/macros/contentful/render-entry.j2", null, function(t_81,t_79) {
if(t_81) { cb(t_81); return; }
t_79.render(context.getVariables(), frame, function(t_82,t_80) {
if(t_82) { cb(t_82); return; }
t_30 += t_80
t_30 += "\n        ";
})});
}
else {
if(runtime.contextOrFrameLookup(context, frame, "moduleType") == "giveawayComponent") {
t_30 += "\n            ";
env.getTemplate("contentful/giveaway-component.j2", false, "core/templates/macros/contentful/render-entry.j2", null, function(t_85,t_83) {
if(t_85) { cb(t_85); return; }
t_83.render(context.getVariables(), frame, function(t_86,t_84) {
if(t_86) { cb(t_86); return; }
t_30 += t_84
t_30 += "\n        ";
})});
}
else {
if(runtime.contextOrFrameLookup(context, frame, "moduleType") == "categoryProductTray") {
t_30 += "\n            ";
t_30 += runtime.suppressValue((lineno = 52, colno = 30, runtime.callWrap(t_16, "productTrayModule", context, [runtime.contextOrFrameLookup(context, frame, "entry"),runtime.contextOrFrameLookup(context, frame, "moduleIndex"),runtime.contextOrFrameLookup(context, frame, "isSpecialtyShop"),runtime.contextOrFrameLookup(context, frame, "entryloopindex"),runtime.makeKeywordArgs({"entryloop": runtime.contextOrFrameLookup(context, frame, "entryloop")})])), env.opts.autoescape);
t_30 += "\n        ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "moduleType") == "mediaSingleModule" || runtime.contextOrFrameLookup(context, frame, "moduleType") == "mediaDualModule" || runtime.contextOrFrameLookup(context, frame, "moduleType") == "tripleContentModule" || runtime.contextOrFrameLookup(context, frame, "moduleType") == "quadContentModule" || runtime.contextOrFrameLookup(context, frame, "moduleType") == "fiveContentModule" || runtime.contextOrFrameLookup(context, frame, "moduleType") == "sixContentModule") {
t_30 += "\n\n            ";
t_30 += runtime.suppressValue((lineno = 60, colno = 24, runtime.callWrap(t_8, "splitModule", context, [runtime.contextOrFrameLookup(context, frame, "entry"),runtime.makeKeywordArgs({"entryloop": runtime.contextOrFrameLookup(context, frame, "entryloop"),"isLazy": runtime.contextOrFrameLookup(context, frame, "isLazy")})])), env.opts.autoescape);
t_30 += "\n\n        ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "moduleType") == "specialtyShop") {
t_30 += "\n            ";
t_30 += runtime.suppressValue((lineno = 63, colno = 24, runtime.callWrap(t_8, "splitModule", context, [runtime.contextOrFrameLookup(context, frame, "entry"),runtime.makeKeywordArgs({"isSpecialtyShop": true,"entryloop": runtime.contextOrFrameLookup(context, frame, "entryloop")})])), env.opts.autoescape);
t_30 += "\n\n        ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "moduleType") == "giveawayModule") {
t_30 += "\n\n            ";
t_30 += runtime.suppressValue((lineno = 67, colno = 27, runtime.callWrap(t_12, "giveawayModule", context, [runtime.contextOrFrameLookup(context, frame, "entry"),runtime.makeKeywordArgs({"isGiveawayModule": true,"entryloop": runtime.contextOrFrameLookup(context, frame, "entryloop")})])), env.opts.autoescape);
t_30 += "\n\n        ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "moduleType") == "shoppableImageComponent") {
t_30 += "\n            ";
env.getTemplate("contentful/shoppable/shoppable-image-component.j2", false, "core/templates/macros/contentful/render-entry.j2", null, function(t_89,t_87) {
if(t_89) { cb(t_89); return; }
t_87.render(context.getVariables(), frame, function(t_90,t_88) {
if(t_90) { cb(t_90); return; }
t_30 += t_88
t_30 += "\n        ";
})});
}
else {
if(runtime.contextOrFrameLookup(context, frame, "moduleType") == "componentProductGrid") {
t_30 += "\n            ";
env.getTemplate("contentful/product-grid/product-grid-component.j2", false, "core/templates/macros/contentful/render-entry.j2", null, function(t_93,t_91) {
if(t_93) { cb(t_93); return; }
t_91.render(context.getVariables(), frame, function(t_94,t_92) {
if(t_94) { cb(t_94); return; }
t_30 += t_92
t_30 += "\n        ";
})});
}
else {
if(runtime.contextOrFrameLookup(context, frame, "moduleType") == "default") {
t_30 += "\n            ";
t_30 += "\n        ";
;
}
else {
t_30 += "\n            ";
t_30 += runtime.suppressValue((lineno = 76, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["unknown-module-type"])), env.opts.autoescape);
t_30 += " ";
t_30 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "moduleType"), env.opts.autoescape);
t_30 += "\n        ";
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
t_30 += "\n    ";
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_30);
});
context.addExport("renderEntry");
context.setVariable("renderEntry", macro_t_29);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/contentful/render-entry.j2"] , dependencies)